import {defineType} from 'sanity'

export const hslaColor = defineType({
  title: 'Hue Saturation Lightness',
  name: 'hslaColor',
  type: 'object',
  fields: [
    {name: 'h', type: 'number', title: 'Hue'},
    {name: 's', type: 'number', title: 'Saturation'},
    {name: 'l', type: 'number', title: 'Lightness'},
    {name: 'a', type: 'number', title: 'Alpha'},
  ],
})
